export const ACCESS_TYPE_VAlUES = [0, 1, 2]

export const ACCESS_TYPE_LABELS = {
  [ACCESS_TYPE_VAlUES[0]]: 'Remove access',
  [ACCESS_TYPE_VAlUES[1]]: 'Can view',
  [ACCESS_TYPE_VAlUES[2]]: 'Can edit',
}
